import { render, staticRenderFns } from "./cover-layer.vue?vue&type=template&id=5ac9378a&"
import script from "./cover-layer.vue?vue&type=script&lang=js&"
export * from "./cover-layer.vue?vue&type=script&lang=js&"
import style0 from "./cover-layer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports